"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendGoToLineEndCommand = exports.GoToLineEndCommand = exports.GoToLineEndCommandBase = void 0;
var tslib_1 = require("tslib");
var layout_position_creator_1 = require("../../../core/layout-engine/layout-position-creator");
var document_layout_details_level_1 = require("../../../core/layout/document-layout-details-level");
var selection_command_base_1 = require("./selection-command-base");
var GoToLineEndCommandBase = (function (_super) {
    tslib_1.__extends(GoToLineEndCommandBase, _super);
    function GoToLineEndCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoToLineEndCommandBase.prototype.executeCore = function (_state, _options) {
        var endSelection = this.getEndPosition();
        if (endSelection < 0)
            return false;
        this.setSelection(endSelection, -1);
        return true;
    };
    GoToLineEndCommandBase.prototype.getEndPosition = function () {
        var selection = this.selection;
        this.endOfLine = true;
        var position = selection.forwardDirection ? selection.lastSelectedInterval.end : selection.lastSelectedInterval.start;
        var subDocument = this.selection.activeSubDocument;
        var layoutPosition = (subDocument.isMain()
            ? new layout_position_creator_1.LayoutPositionMainSubDocumentCreator(this.control.layout, subDocument, position, document_layout_details_level_1.DocumentLayoutDetailsLevel.Character)
            : new layout_position_creator_1.LayoutPositionOtherSubDocumentCreator(this.control.layout, subDocument, position, selection.pageIndex, document_layout_details_level_1.DocumentLayoutDetailsLevel.Character))
            .create(new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(selection.endOfLine), new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(false));
        if (!layoutPosition)
            return -1;
        return this.getEndPositionCore(layoutPosition);
    };
    return GoToLineEndCommandBase;
}(selection_command_base_1.SelectionCommandBase));
exports.GoToLineEndCommandBase = GoToLineEndCommandBase;
var GoToLineEndCommand = (function (_super) {
    tslib_1.__extends(GoToLineEndCommand, _super);
    function GoToLineEndCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoToLineEndCommand.prototype.setSelection = function (pos, keepX) {
        var selection = this.selection;
        selection.deprecatedSetSelection(pos, pos, this.endOfLine, keepX, true);
    };
    GoToLineEndCommand.prototype.getEndPositionCore = function (layoutPosition) {
        var lastBoxInRow = layoutPosition.row.getLastVisibleBox();
        if (!lastBoxInRow)
            this.endOfLine = false;
        return layoutPosition.getLogPosition(document_layout_details_level_1.DocumentLayoutDetailsLevel.Row) + (lastBoxInRow ? lastBoxInRow.getEndPosition() : 0);
    };
    return GoToLineEndCommand;
}(GoToLineEndCommandBase));
exports.GoToLineEndCommand = GoToLineEndCommand;
var ExtendGoToLineEndCommand = (function (_super) {
    tslib_1.__extends(ExtendGoToLineEndCommand, _super);
    function ExtendGoToLineEndCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtendGoToLineEndCommand.prototype.setSelection = function (pos, keepX) {
        var _this = this;
        this.selection.changeState(function (newState) { return newState.extendLastInterval(pos).setKeepX(keepX).setEndOfLine(_this.endOfLine); });
    };
    ExtendGoToLineEndCommand.prototype.getEndPositionCore = function (layoutPosition) {
        return layoutPosition.getLogPosition(document_layout_details_level_1.DocumentLayoutDetailsLevel.Row) + layoutPosition.row.getLastBoxEndPositionInRow();
    };
    return ExtendGoToLineEndCommand;
}(GoToLineEndCommandBase));
exports.ExtendGoToLineEndCommand = ExtendGoToLineEndCommand;
